import AdminClient from '../client/AdminClient';
import _ from "lodash";
import {mapIds} from "../../../helpers/utils";

class PwtWarningsService {
    static async index(session, params) {
        const filterParams = this.parsedFilterParams(params.filterParams);
        return AdminClient.get(`/v1/admin/pwt_warnings`, session,
            {
                ...params,
                filterParams: filterParams,
            }
        );
    }

    static async update(warningId, session, warning) {
        return AdminClient.put(`/v1/admin/pwt_warnings/${warningId}`, session, warning);
    }

    static async warnAll(session) {
        return AdminClient.post(`/v1/admin/pwt_warnings/warn_all`, session);
    }

    static parsedFilterParams(params) {
        if (!_.isEmpty(params)) {
            return {
                ...params,
                researchers: mapIds(params.researchers),
                type_of_warning: mapIds(params.type_of_warning),
            }
        } else {
            return params;
        }
    }
}

export default PwtWarningsService;